module.exports = __webpack_public_path__ + "img/image1.2ccc1b4f.jpg";